import React, { Fragment } from "react";
import { Parallax } from "react-scroll-parallax";
import { ReactSVG } from "react-svg";
import heart from "../../assets/shapes/heart.svg";
import marquisePat from "../../assets/shapes/marquisePat.svg";
import ogPat from "../../assets/shapes/ogPat.svg";

import Showcase from "../common/Showcase";
import Media from "react-media";
import styles from "./Inspiration.module.scss";
import { MOBILE_WIDTH } from "../../constants";
import imageSource from '../../assets/screenshots/3-inspirations.png'

const inspiration = {
  title: "Inspiration",
  content:
    "A place for you to snap or save the things that inspire you to be better whether that be loved ones, mentors, quotes, people you are envious of etc...",
  featureTitle: "Features",
  features: [
    "Easily add images and use them as inspiration.",
    'Leave a quick note on what it is about this that drives your "why".'
  ],
  imageSource
};

const {
  centerStyle,
  centerCluster,
  center,
  centerSM,
  border,
  marq,
  ogStyle
} = styles;

const Inspiration = props => {
  return (
    <Fragment>
      <Showcase item={inspiration} bubbleStyle={border}>
        <Parallax  translateX={[-50, 100]} className={ogStyle}>
          <ReactSVG src={ogPat} />
        </Parallax>

        <Parallax
          translateY={[-200, 300]}
          translateX={[25, 75]}
          className={marq}
        >
          <ReactSVG src={marquisePat} />
        </Parallax>

        <div className={centerCluster}>
          <Parallax translateY={[100, -100]} className={centerStyle}>
            <Media query={{ maxWidth: MOBILE_WIDTH }}>
              {matches => (
                <ReactSVG
                  src={heart}
                  className={`${matches ? centerSM : center}`}
                />
              )}
            </Media>
          </Parallax>
        </div>
      </Showcase>
    </Fragment>
  );
};

export default Inspiration;
